import { render, staticRenderFns } from "./desktop-header.vue?vue&type=template&id=29777541&scoped=true"
import script from "./desktop-header.vue?vue&type=script&lang=js"
export * from "./desktop-header.vue?vue&type=script&lang=js"
import style0 from "./desktop-header.vue?vue&type=style&index=0&id=29777541&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29777541",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29777541')) {
      api.createRecord('29777541', component.options)
    } else {
      api.reload('29777541', component.options)
    }
    module.hot.accept("./desktop-header.vue?vue&type=template&id=29777541&scoped=true", function () {
      api.rerender('29777541', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/desktop/desktop-header.vue"
export default component.exports